import React from "react";
import { useState } from "react";
import { CSVLink } from "react-csv";
import Header from "./components/Header";
import Address from "./components/Address";
import Table from "./components/Table";
import Footer from "./components/Footer";
import * as solanaWeb3 from "@solana/web3.js";

import "./css/mdb.dark.min.css";
import LoadingSpinner from "./components/Loading";

const App = () => {
  const [rewards, setRewards] = useState([]);
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState();
  const [account, setAccount] = useState("");
  const [error, setError] = useState("");

  const columns = React.useMemo(
    () => [
      {
        Header: "Epoch",
        accessor: "epoch",
      },
      {
        Header: "Amount SOL",
        accessor: "amount",
      },
      {
        Header: "Date Awarded",
        accessor: "date",
      },
      {
        Header: "SOL USD Price",
        accessor: "usd",
      },
      {
        Header: "USD Total",
        accessor: "usdtotal",
      },
    ],
    []
  );

  /*const data = React.useMemo(
    () => [
      {
        epoch: 200,
        amount: 10,
        time: "10/01/2021",
      },
      {
        epoch: 201,
        amount: 11,
        time: "10/03/2021",
      },
      {
        epoch: 202,
        amount: 12,
        time: "10/05/2021",
      },
    ],
    []
  );*/

  async function accountInfo(key, url) {
    const connection = new solanaWeb3.Connection(url);
    let accountInfo = connection.getParsedAccountInfo(
      new solanaWeb3.PublicKey(key)
    );
    return await accountInfo;
  }

  async function inflationReward(key, url, epoch) {
    const connection = new solanaWeb3.Connection(url);
    let rewardEpoch = parseInt(epoch);
    let reward = connection.getInflationReward(
      [new solanaWeb3.PublicKey(key)],
      rewardEpoch
    );
    return await reward;
  }

  async function blockTime(url, slot) {
    const connection = new solanaWeb3.Connection(url);
    let unix = connection.getBlockTime(slot);
    return await unix;
  }

  async function currentEpoch(url) {
    const connection = new solanaWeb3.Connection(url);
    let currentEpoch = connection.getEpochInfo();
    return await currentEpoch;
  }

  function convertUnixTime(unix) {
    let milliseconds = unix * 1000;
    let dateObject = new Date(milliseconds);
    dateObject.timeZone = "UTC";
    dateObject.timeZoneName = "short";
    let day = dateObject.getUTCDate();
    let digit2day = (day < 10 ? "0" : "") + day;
    let month = dateObject.getUTCMonth() + 1;
    let digit2month = (month < 10 ? "0" : "") + month;
    let year = dateObject.getUTCFullYear();
    let formattedTime = digit2day + "-" + digit2month + "-" + year;
    return formattedTime;
  }

  function getSolUSDPrice(time) {
    const priceData = require("./sol_price.json");
    const usd = priceData[time].toFixed(2);
    return usd;
  }

  const stakeRewards = async () => {
    try {
      let key = address;
      if (!address) {
        let stakeRewards = [];
        return stakeRewards;
      }
      let url = "https://api.mainnet-beta.solana.com";
      let data = await accountInfo(key, url);
      let accountType = data.value.data.program;
      if (!accountType) {
        let stakeRewards = [];
        setAccount("nonstake");
        return stakeRewards;
      }
      let activationEpoch =
        data.value.data.parsed.info.stake.delegation.activationEpoch;
      activationEpoch++;
      let nowEpoch = await currentEpoch(url);
      let epoch = 263;
      console.log(epoch)
      /*let epoch = nowEpoch.epoch;*/
      let stakeRewards = [];
      while (activationEpoch < epoch) {
        let epochReward = await inflationReward(key, url, activationEpoch);
        let amount = epochReward[0].amount / 1000000000;
        let amountfixed = amount.toFixed(9);
        let slot = epochReward[0].effectiveSlot;
        let dtg = await blockTime(url, slot);
        let time = convertUnixTime(dtg);
        let epochRewards = {};
        epochRewards.epoch = activationEpoch;
        epochRewards.amount = amountfixed;
        epochRewards.date = time;
        try {
          epochRewards.usd = getSolUSDPrice(time);
          let totalusd = epochRewards.amount * epochRewards.usd;
          epochRewards.usdtotal = totalusd.toFixed(2);
        } catch (err) {
          epochRewards.usd = "unknown";
          epochRewards.usdtotal = "unknown";
        }
        console.log(epochRewards);
        stakeRewards.push(epochRewards);
        activationEpoch++;
      }
      return stakeRewards;
    } catch (err) {
      let stakeRewards = [];
      setError("error");
      console.log(err);
      return stakeRewards;
    }
  };

  const handleInput = (event) => {
    setAddress(event.target.value);
  };

  const getStakeRewards = () => {
    setLoading(true);
    setRewards([]);
    setError("");
    setAccount("");
    displayRewards();
  };

  const displayRewards = () => {
    const getRewards = async () => {
      const userRewards = await stakeRewards();
      setRewards(userRewards);
      setLoading(false);
    };
    getRewards();
  };

  const headers = [
    {
      label: "Epoch",
      key: "epoch",
    },
    {
      label: "Amount SOL",
      key: "amount",
    },
    {
      label: "Date Awarded",
      key: "date",
    },
    {
      label: "SOL USD Price",
      key: "usd",
    },
    {
      label: "USD Total",
      key: "usdtotal",
    },
  ];

  const csvReport = {
    filename: "stake_rewards.csv",
    headers: headers,
    data: rewards,
  };

  if (rewards.length === 0 && error.includes("error")) {
    return (
      <div className="App">
        <body className="d-flex flex-column min-vh-100">
          <Header />
          <Address input={handleInput} run={getStakeRewards} />

          <p className="position-absolute top-50 start-50 translate-middle fs-3 fw-bold">
            Failed to load staking data. Please try again.
          </p>
          <Footer />
        </body>
      </div>
    );
  }

  if (rewards.length === 0 && account.includes("nonstake")) {
    return (
      <div className="App">
        <body className="d-flex flex-column min-vh-100">
          <Header />
          <Address input={handleInput} run={getStakeRewards} />

          <p className="position-absolute top-50 start-50 translate-middle fs-3 fw-bold">
            Account is not a staking account.
          </p>
          <Footer />
        </body>
      </div>
    );
  }

  if (rewards.length === 0) {
    return (
      <div className="App">
        <body className="d-flex flex-column min-vh-100">
          <Header />
          <Address input={handleInput} run={getStakeRewards} />

          {loading ? (
            <LoadingSpinner />
          ) : (
            <Table columns={columns} data={rewards} />
          )}
          <Footer />
        </body>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Address input={handleInput} run={getStakeRewards} />

      {loading ? (
        <LoadingSpinner />
      ) : (
        <Table columns={columns} data={rewards} />
      )}
      <CSVLink className="col-sm-1 btn btn-light ms-5 mb-5" {...csvReport}>
        Export to CSV
      </CSVLink>
      <Footer />
    </div>
  );
};

export default App;
